<template>
    <div class="storage-allocation">
        <compWrapper theme="primary" title="基本信息">
            <compFormQuery
                v-if="queryType == 'query'"
                class="margin-top-15 margin-right-30 margin-left-30"
                :formdata="getBase"
                :value="formData"
                :labelWidth="130"
                :col="1"
                placeholder="--"
            >
            </compFormQuery>

            <compFormEdit
                v-else
                class="margin-top-15 margin-right-30 margin-left-30"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="130"
                :col="1"
            >
            </compFormEdit>
             <vButtonGroup slot="footer" v-if="queryType !== 'query'">
				<vButton theme="primary" @click="submit">保存</vButton>
				<vButton @click="cancel">返回</vButton>
			</vButtonGroup>
        </compWrapper>
        <div class="update-log" v-if="queryType === 'query'">
            <compWrapper title="操作记录" theme="warning">
                <Table class="margin-15" :columns="columns" :data="tableData" size="small"></Table>
            </compWrapper>
        </div>
         <vButtonGroup class="text-right"  v-if="queryType === 'query'">
				<vButton @click="cancel">返回</vButton>
			</vButtonGroup>
            <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetOutboundDetail,HttpSaveOutboundCalculate,HttpHostWarehouseOrganization,HttpHostAndFbaWarehouse,HttpHostAndCustomerWarehouse } from '@/service/storageallocation';
import {  mapGetters } from "vuex";

export default {
    props: ['type', 'activeid'],
    data() {
        return {
             loading: false,
            queryType: this.type ? this.type : this.$route.params.type,
            formData: {
                // capacity: null
            },
            warehouseList: [],
            organizationeList:[],
        };
    },
     async created () {
           // 获取客户
         await HttpHostWarehouseOrganization().then(res => {
            this.organizationeList = res.data.map(item => {
                return {
                    value: item.id, 
                    label: item.name, 
                    attach: {
                        ...item
                    }
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
        if (this.queryType !== 'add') {
            console.log(this.activeid)
            this.update();
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getBillcusorgList", "getBillcusAndFbaWareList"]),
        getBase() {
            return [
                {
                    label: "选择客户",
                    key: "organizationId",
                    query: this.queryType === "query",
                    options: this.organizationeList ,
                    required: true,
                    tag: "Select",
                    props: {
                        filterable: true,
                    },
                     on: {
                        'on-change': (val) => {
                            this.getWarehouse(val);
                        }
                    }
                },
                {
                    label: "选择仓库",
                    key: "orgWarehouseId",
                    query: this.queryType === 'query',
                    options: this.warehouseList,
                    tag: "Select",
                    props: {
                        filterable: true
                    },
                    on: {
                          'on-change': (val) => {
                            this.formData.orgWarehouseCode = this.warehouseList.filter(item => {
                                return item.value === val;
                            })[0].attach.code;
                        }
                    }
                   
                },
                 {
                    label: '日期',
                    key: 'calculateOutboundAt',
                    query: this.queryType === 'query',
                    tag: 'vDatepicker',
                    props: {
                        format: "yy-mm-dd",
                            },
                },
                {
                    label: '出库预测(CBM)',
                    key: 'calculateQty',
                    query: this.queryType === 'query',
                    tag: 'vInputNumber',
                    props:{
						min:0.0001
					}
                }
            ];
        },
         columns () {
            return [
                {
                    title: '操作类型',
                    render: (h, { row }) => {
                        let type = '';
                        switch (row.operateType) {
                            case 1: {
                                type = '创建'
                                break;
                            }
                            case 2: {
                                type = '更新'
                                break;
                            }
                        }
                        return <div>{type}</div>
                    }
                },
                {
                    title: '操作人',
                    key: 'updatedName',
                },
                 {
                    title: '操作前数据',
                    key: 'beforeValue',
                },
                 {
                    title: '操作后数据',
                    key: 'afterValue',
                },
                {
                    title: '操作时间',
                    key: 'updatedAt'
                }
            ]
        },
    },
    methods: {
         getWarehouse(orgId) {
            HttpHostAndCustomerWarehouse({
                contextId:global.SYSID,
                orgId: orgId,
            }).then(
                (res) => {
                    this.warehouseList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: `${item.code}(${item.title})`,
                            attach: {
                                ...item
                            }
                        }
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
       async update () {
            HttpGetOutboundDetail({
                contextId: global.SYSID,
                id: this.activeid ||this.$route.query.id
            }).then(res => {
                this.formData = {
                    ...res.data.warehouseOutboundCalculateEntity
                };
                this.tableData = res.data.updateLogEntities;
                 if(this.formData.organizationId){
                HttpHostAndCustomerWarehouse({
                    contextId:global.SYSID,
                    orgId: this.formData.organizationId,
                }).then(res => {
                    this.warehouseList = res.data.map(item => {
                         return {
                            value: item.id,
                            label: `${item.code}(${item.title})`,
                            attach: {
                                ...item
                            }
                        }
                 });
                }, err => {
                this.$VMessage.error(err.message);
                });
             }
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        // 保存
        async submit () {
            const valid = await this.$refs.editform.validate()
            if (!valid) return;
            this.loading = true;
            HttpSaveOutboundCalculate({
                id:this.queryType === 'add' ? 0 : this.$route.query.id,
                contextId:this.formData.organizationId,
                orgWarehouseId:this.formData.orgWarehouseId,
                orgWarehouseCode:this.formData.orgWarehouseCode,
                calculateQty:this.formData.calculateQty,
                calculateOutboundAt:this.formData.calculateOutboundAt
            }).then(res => {
                this.loading = false;
                this.$VMessage.success(res.message);
                this.cancel();
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
            });
        },
        cancel () {
            this.$router.push({
                name: 'outboundCalculateDetail'
            });
             this.$emit("on-update");
        }
    },
};
</script>

<style>
</style>